/**
 * SplittingController
 * `[data-splitting]` 属性が付いた全要素を Splitting.js で 1文字ずつ分割する。
 *
 * 出力構造 (Splitting.js が自動生成):
 *   <h3 data-splitting style="--word-total: N; --char-total: N">
 *     <span class="word" data-word="ORSAY" style="--word-index: 0">
 *       <span class="char" data-char="O" style="--char-index: 0">O</span>
 *       ...
 *     </span>
 *   </h3>
 *
 * ホバー時のフリップ演出は `.is-hover` クラスで発火 (_base.scss)。
 * このコントローラは以下の場合に `is-hover` をトグルする:
 *   - [data-splitting] 自身の mouseenter/leave
 *   - 祖先に [data-splitting-hover] があればそれの mouseenter/leave
 *     (親カード全体を hover したら中の text がフリップする用途)
 * 他JS (scroll-trigger 等) から手動で classList.add('is-hover') しても発火する。
 */
import Splitting from 'splitting';

export const SplittingController = {
  init() {
    const targets = document.querySelectorAll( '[data-splitting]' );
    if ( !targets.length ) return;
    Splitting( { target: targets, by: 'chars' } );

    targets.forEach( ( el ) => {
      // 祖先に [data-splitting-hover] があれば hover トリガーはそちら。
      // なければ [data-splitting] 自身をトリガーとする。
      const trigger = el.parentElement?.closest( '[data-splitting-hover]' ) || el;
      trigger.addEventListener( 'mouseenter', () => el.classList.add( 'is-hover' ) );
      trigger.addEventListener( 'mouseleave', () => el.classList.remove( 'is-hover' ) );
    } );

    // [data-splitting-hover] グループ内の複数 [data-splitting] を「1つの流れ」として
    // 扱うため、内部の .char に付いている --char-index を全体連番で振り直す。
    // 例: date="2025.10.15" (10文字) + title="Hello" (5文字) の場合、
    //     date は 0..9、title は 10..14 になり、hover 時に左端から順にフリップする。
    const groups = document.querySelectorAll( '[data-splitting-hover]' );
    groups.forEach( ( group ) => {
      const chars = group.querySelectorAll( '[data-splitting] .char' );
      chars.forEach( ( ch, i ) => {
        ch.style.setProperty( '--char-index', i );
      } );
    } );
  },
};
